
export default {
  components: {
  },
  data () {
    return {
    };
  },

  methods: {
    // 资源资产登记
    addAssets (e) {
      this.$router.push({ path: '/person-center/resources-assets/add?asstesType=' + e });
    }
  }
};

